import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

interface PackUnits {
  id: any;
  packUnit: string;
}

interface PackUnitsState {
  data: PackUnits[];
  loading: boolean;
  error: string | null;
}

const PORT = import.meta.env.VITE_COOK_PORT;
const MASTERURL = import.meta.env.VITE_API_COOK_URL;

export const fetchPackUnits = createAsyncThunk<PackUnits[], void, { rejectValue: string }>(
  'packUnit/fetchPackUnits',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.get<{ data: PackUnits[] }>(
        '/get_all_food_pack_unit',
        PORT,
        MASTERURL,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
    }
  },
);

export const createPackUnit = createAsyncThunk<PackUnits, any, { rejectValue: string }>(
  'packUnit/createPackUnit',
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiService.post<{ data: PackUnits }>(
        '/create_food_pack_unit',
        params,
        PORT,
        MASTERURL,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
    }
  },
);

export const updatePackUnit = createAsyncThunk<PackUnits, any, { rejectValue: string }>(
  'packUnit/updatePackUnit',
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiService.put<{ data: PackUnits }>(
        '/update_food_pack_unit',
        params,
        PORT,
        MASTERURL,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
    }
  },
);
export const softDeleteUnitPack = createAsyncThunk<{ id: number }, number, { rejectValue: string }>(
  'packUnit/softDeleteUnitPack',
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiService.patch<{ data: { id: number } }>(
        `/soft_delete_food_pack_unit?id=${id}`,
        {},
        PORT,
        MASTERURL,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : 'An error occurred while deleting pack unit',
      );
    }
  },
);

export const packUnitsSlice = createSlice({
  name: 'packUnit',
  initialState: {
    data: [],
    loading: false,
    error: null,
  } as PackUnitsState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPackUnits.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPackUnits.fulfilled, (state, action: PayloadAction<PackUnits[]>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchPackUnits.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'Unknown error';
      });
  },
});

export default packUnitsSlice.reducer;
